<template>
  <div class="section-playback-timeline">
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">Events</h1>
      </div>
      <div class="section-body">
        <div class="event-container">
          <div class="event-list" ref="eventlist">
            <div class="remark">
              <span><i class="fas fa-info-circle"></i></span>
              ค่า Buffer Health และ Response Time เป็นค่าที่มาจากการสุ่มเช็คคุณภาพการเล่น จึงอาจมีกรณีที่ไม่มีค่าเกิดขึ้นได้
            </div>
            <div class="item-container item-header-container">
              <div class="item item-date"></div>
              <div class="item item-primary">Type</div>
              <div class="item item-res">Playhead</div>
              <div class="item item-res">Resolution</div>
              <div class="item item-optional"
                title="Bandwidth Estimate คือความเร็วอินเทอร์เน็ตโดยประมาณจาก Video Player">
                <span class="title">BW Estimate</span>
                <small>(Mbit / sec)</small>
              </div>
              <div class="item item-optional">
                <span class="title">Buffer Health
                  <span><i class="fas fa-info-circle"></i></span>
                </span>
                <small>(sec)</small>
              </div>
              <div class="item item-optional">
                <span class="title">Response Time <span><i class="fas fa-info-circle"></i></span></span>
                <small>(sec)</small>
              </div>
              <div class="item item-issue">Note</div>
            </div>
            <div v-if="eventIds.length > 0 && !isEmpty() && !isError()">
              <EventListItem
                v-for="(item, index) in eventIds"
                :key="index"
                :indexItem="index"
                :data="getEventById(item)" />
            </div>
            <EmptyMessage
              v-if="isEmpty()">
              ไม่พบข้อมูล
            </EmptyMessage>
            <EmptyMessage v-if="isError()">
              <h3>พบข้อผิดพลาดระหว่างโหลดข้อมูล</h3>
              <p>
                โปรดรอซักครู่เพื่อโหลดข้อมูลใหม่ หรือติดต่อ
                <a
                  :href="`mailto:support@byteark.com`"
                  target="_top"
                >support@byteark.com</a>
              </p>
              <span slot="code" class="code">error code : {{error.status || 'not found' }}</span>
            </EmptyMessage>
            <div v-if="stateEventList.isLoading" class="d-flex justify-content-center">
              <div class="spinner-border" role="status" />
            </div>
          </div>
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
/* eslint camelcase: "off" */
import { mapGetters } from 'vuex';
import dateFormatter from '@/utils/dateFormatter';
import unitFormatter from '@/utils/unitFormatter';
import Section from '@/components/Section.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import EventListItem from '@/playback/EventListItem.vue';

export default {
  mixins: [dateFormatter, unitFormatter],
  components: {
    Section,
    EmptyMessage,
    EventListItem,
  },
  data() {
    return {
      currentScrollID: '',
    };
  },
  created() {
    this.scroll();
  },
  computed: {
    ...mapGetters(['eventIds', 'stateEventList', 'getEventById']),
  },
  methods: {
    scroll() {
      window.onscroll = () => {
        const bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight
        === document.documentElement.offsetHeight;
        if (bottomOfWindow) {
          if (!this.isEmpty() && !this.isError()) {
            this.$emit('onPageBottom');
          }
        }
      };
    },
    isEmpty() {
      if (this.eventIds.length > 0) {
        return false;
      }
      return this.stateEventList.isLoading
        && this.stateEventList.isEmpty
        && !this.stateEventList.isError;
    },
    isError() {
      if (this.eventIds.length > 0) {
        return false;
      }
      return !this.stateEventList.isLoading && this.stateEventList.isError;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/event-list.scss';

.event-container {
  display: flex;

  .filter {
    flex: 0 0 250px;
    height: auto;
    margin-right: $spacer * 2;
  }

  .event-list {
    // flex: 1 0 auto;
    width: 100%;
    overflow-x: auto;
    .remark {
      display: flex;
      justify-content: flex-end;
      margin-bottom: $spacer * 0.5;
      font-size: $font-size-sm;
    }
  }
}

.filter {
  margin-top: $spacer * 4.5;

  .filter-group {
    margin-bottom: $spacer * 0.75;
    font-weight: bold;
  }

  .filter-item {
    margin-bottom: $spacer * 0.5;
  }
}


@media (max-width: 767.98px) {
  .event-list {
    // overflow-x: auto;
    .remark {
      margin-bottom: $spacer * 0.25 !important;
      font-size: $font-size-sm * 0.875 !important;
      > span {
        margin-right: $spacer / 2;
      }
    }
  }
}

</style>
